import { render, staticRenderFns } from "./PostPostCard.vue?vue&type=template&id=37dd1bac&scoped=true&lang=pug&"
import script from "./PostPostCard.vue?vue&type=script&lang=js&"
export * from "./PostPostCard.vue?vue&type=script&lang=js&"
import style0 from "./PostPostCard.vue?vue&type=style&index=0&id=37dd1bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd1bac",
  null
  
)

export default component.exports